module.exports = __webpack_public_path__ + "static/og-7a83f79070cb88a85df351d652cb6c8d.png";